import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Avatar,
  Box,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ProfileCard = ({ profile, onEdit = () => {}, onDelete }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Avatar src={profile.logo_url} sx={{ width: 48, height: 48 }}>
            {profile.name?.charAt(0)}
          </Avatar>
          <Typography variant="h6">{profile.name}</Typography>
        </Box>
        <Typography color="textSecondary">{profile.email}</Typography>
      </CardContent>
      <CardActions>
        <Button startIcon={<Edit />} onClick={() => onEdit(profile)}>
          {t("common.actions.edit")}
        </Button>
        <Button
          startIcon={<Delete />}
          color="error"
          onClick={() => onDelete(profile.id)}
        >
          {t("common.actions.delete")}
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProfileCard;
